import React from 'react';
import { Box, Button, useBreakpointValue } from '@chakra-ui/react';
import { GoArrowUpRight } from 'react-icons/go';
import { CustomText, CustomTextProps } from '../atoms/CustomText';
import { JaggedBorderFooter } from '../atoms/JaggedBorderFooter';
import { JaggedBorderFooterMobile } from '../atoms/JaggedBorderFooterMobile';

interface ContactBtnSectionProps {
  onButtonClick?: () => void; // Define the type for the onButtonClick function
  variant: CustomTextProps['variant'];
  color?: string;
  fontSize?: string;
  fontWeight?: string;
  buttonBgColor?: string;
  needHelpTextColor?: string;
  needHelpText?: string;
  pt?: string;
  pb?: string;
  contactUsButtonText?: string;
  showJaggedBorder?: boolean;
  showRocks?: boolean;
  footerBgColor?: string;
  rocksImageUrl?: string;
  contactUsHref?: () => string | undefined;
}

export const ContactBtnSection: React.FC<ContactBtnSectionProps> = ({
  onButtonClick,
  variant = 'h1',
  color = 'primary',
  fontSize = '40px',
  fontWeight = 'bold',
  buttonBgColor = 'black',
  needHelpTextColor = 'black',
  needHelpText = 'Need More Help?',
  pt,
  pb,
  contactUsButtonText,
  showJaggedBorder,
  showRocks,
  footerBgColor,
  rocksImageUrl,
  contactUsHref,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      pt={pt}
      backgroundImage={showRocks ? `url(${rocksImageUrl})` : undefined}
      backgroundRepeat="no-repeat"
      backgroundPosition={{
        base: 'center bottom',
        sm: 'center calc(100% - 50px)',
        md: 'center calc(100% - 60px)',
        lg: 'center calc(100% - 20px)',
      }}
      backgroundSize="100% auto"
      position="relative"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%" // important for vertical centering
        paddingX="2rem"
        textAlign="center"
        pb={pb}
      >
        <CustomText
          variant={variant}
          color={needHelpTextColor}
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {needHelpText}
        </CustomText>
        <a href={contactUsHref ? contactUsHref() : undefined} style={{ textDecoration: 'none' }}>
          <Button
            rightIcon={<GoArrowUpRight />}
            // onClick={onButtonClick}
            onClick={e => {
              const isLeftClick = e.button === 0;
              const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
              // SPA routing on normal click
              if (isLeftClick && !isModifiedClick) {
                e.preventDefault();
                onButtonClick?.();
              }
            }}
            variant="solid"
            size="md"
            colorScheme="black" // Default color scheme
            fontSize="lg"
            textColor={color}
            bg={buttonBgColor}
            borderRadius="0"
            border="2px solid #051E3B"
            my="4vh"
            _hover={{ boxShadow: 'md', transform: 'scale(1.05)' }}
            fontWeight="bold"
            padding="8px 16px"
            type="button"
          >
            {contactUsButtonText}
          </Button>
        </a>
      </Box>
      {/* Jagged Border */}
      {showJaggedBorder &&
        (isMobile ? (
          <Box position="absolute" bottom="0" width="100%" zIndex="0">
            <JaggedBorderFooterMobile bgColor={footerBgColor} />
          </Box>
        ) : (
          <Box position="absolute" bottom="0" width="100%" zIndex="0">
            <JaggedBorderFooter bgColor={footerBgColor} />
          </Box>
        ))}
    </Box>
  );
};
